import React from 'react';

const IconRwb = props => (<svg viewBox="0 0 10 8" width="10px" height="8px" {...props}>
  <path d="M4.999,8L0,4l4.999-4" />
  <path d="M10,8L5.002,4L10,0" />
</svg>);

export default IconRwb;
